// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import PageHeader from '../../PageHeader.jsx';
import ContentBox from '../../ContentBox.jsx';
import NotesCard from './NotesCard.jsx';

import type { Note } from '../../../util/aggregatedNotesUtil';
import { getAllNotes } from '../../../util/aggregatedNotesUtil';

type Props = {
  patient: Object,
}

// Potential feature: filter where the notes come from.
type State = {}

class AggregatedNotesComponent extends Component<Props, State> {
  render() {
    const notes: Note[] = [];
    getAllNotes(notes, this.props.patient);
    notes.sort((n1, n2) => {
      // Note: lastEditDate should never be null. If it is found to be null,
      // sort it to the end.
      if (!n1.lastEditDate && !n2.lastEditDate) { return 0; }
      if (!n1.lastEditDate && n2.lastEditDate) { return 1; }
      if (n1.lastEditDate && !n2.lastEditDate) { return -1; }
      // $FlowFixMe
      return n1.lastEditDate >= n2.lastEditDate ? -1 : 1;
    });
    const cards = notes.map(note => <NotesCard key={note._id} note={note} />);

    return (
      <div>
        <PageHeader title="Aggregated Notes" />
        <ContentBox>
          This page aggregates notes from various sources, sorted by edit date (most recent first).
          The sources used are: diagnoses, medications, interventions, nurse notes, provider notes,
          vital signs, immunizations, wccs, tests, growth measurements, and external reports.
        </ContentBox>
        <div>
          { cards }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  patient: state.patient.data,
});

const AggregatedNotesPage = connect(
  mapStateToProps,
)(AggregatedNotesComponent);

export default AggregatedNotesPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/aggregatedNotes/AggregatedNotesPage.jsx